import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "py-5",
  style: {"min-height":"650px"}
}
const _hoisted_2 = {
  class: "mb-3",
  style: {"line-height":"1.5"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  class: "alert alert-secondary",
  role: "alert"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 1,
  class: "my-5"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", null, "Current Plan", -1 /* HOISTED */)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, " To switch to our new plans, email us on support@erpnext.com ", -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CartSkeleton = _resolveComponent("CartSkeleton")
  const _component_Plans = _resolveComponent("Plans")
  const _component_PlanCard = _resolveComponent("PlanCard")
  const _component_Addons = _resolveComponent("Addons")
  const _component_Checkout = _resolveComponent("Checkout")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, [
      _createTextVNode("Manage subscription for "),
      _createElementVNode("mark", null, _toDisplayString($options.site_name), 1 /* TEXT */)
    ]),
    (!$data.site)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(1, (index) => {
            return _createVNode(_component_CartSkeleton, { key: index })
          }), 64 /* STABLE_FRAGMENT */))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              ($data.site.subscription_status == 'Trial')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createTextVNode(" Your trial expires on "),
                    _createElementVNode("b", null, _toDisplayString($data.formatted_expiry), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              ($data.site.subscription_status == 'Paid')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createTextVNode(" Your current subscription expires on "),
                    _createElementVNode("b", null, _toDisplayString($data.formatted_expiry), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(" Number of users in current subscription: "),
              _createElementVNode("b", null, _toDisplayString($data.site.users), 1 /* TEXT */)
            ])
          ]),
          (!$data.legacy_plan)
            ? (_openBlock(), _createBlock(_component_Plans, {
                key: 0,
                class: "my-5",
                plans: $data.plans,
                site: $data.site,
                cart: $data.cart,
                legacy_plan: $data.legacy_plan,
                onChangeBillingCycle: _cache[0] || (_cache[0] = value => $data.cart.billing_cycle = value),
                onChangePlan: _cache[1] || (_cache[1] = value => $data.cart.plan = value)
              }, null, 8 /* PROPS */, ["plans", "site", "cart", "legacy_plan"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_PlanCard, {
                      plan: $data.legacy_plan,
                      is_active: true,
                      currency: $data.site.currency,
                      billing_cycle: 'Yearly'
                    }, null, 8 /* PROPS */, ["plan", "currency"])
                  ])
                ]),
                _hoisted_12
              ])),
          ($data.addons)
            ? (_openBlock(), _createBlock(_component_Addons, {
                key: 2,
                class: "my-5",
                site: $data.site,
                plans: $data.plans,
                selected_plan: $data.cart.plan,
                addons: $data.addons,
                site_users: $data.site_users,
                billing_cycle: $data.cart.billing_cycle,
                onAddAddon: $options.add_addon
              }, null, 8 /* PROPS */, ["site", "plans", "selected_plan", "addons", "site_users", "billing_cycle", "onAddAddon"]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_Checkout, {
            cart_details: $data.cart_details,
            cart: $data.cart,
            site: $data.site,
            address: $data.address,
            pending_downgrades: $data.pending_downgrades,
            erpnext_partner: $options.erpnext_partner,
            legacy_plan: $data.legacy_plan,
            plan_wise_discount: $data.plan_wise_discount,
            email: $options.email,
            onPay: $options.pay,
            onAddress: $options.show_address_dialog,
            onRemove_from_cart: $options.remove_from_cart,
            onProcess_downgrade: $options.process_downgrade,
            onCancel_downgrade: $options.cancel_downgrade,
            onSwitch_billing_cycle: $options.switch_billing_cycle
          }, null, 8 /* PROPS */, ["cart_details", "cart", "site", "address", "pending_downgrades", "erpnext_partner", "legacy_plan", "plan_wise_discount", "email", "onPay", "onAddress", "onRemove_from_cart", "onProcess_downgrade", "onCancel_downgrade", "onSwitch_billing_cycle"])
        ]))
  ]))
}